import React, { useState, useRef, useImperativeHandle } from "react";
import moment from "moment";
import { Form, Tooltip, OverlayTrigger } from "react-bootstrap";
import { forwardRef } from "react";
import { useEffect } from "react";
import api from "./services/api";

export const calculateSum = (array, property, cancelProperty) => {
  const total = array.reduce((accumulator, object) => {
    return object[cancelProperty] !== true
      ? accumulator + parseFloat(object[property])
      : accumulator + 0;
  }, 0);

  return total;
};

export const DateFormat = ({
  value,
  timeOnly = false,
  dateTime = false,
  format = null,
}) => {
  let val;
  try {
    const dt = new Date(value);
    if (format) val = moment(dt).format(format);
    else if (dateTime) val = dt.toLocaleString();
    else if (timeOnly) val = dt.toLocaleTimeString();
    else val = dt.toLocaleDateString();
  } catch (e) {
    console.error(e);
    val = "Unknown";
  }

  return (
    <>
      <span className="fst-italic">{val}</span>
    </>
  );
};

export const getInitials = (name) => {
  return name
    .match(/(^\S\S?|\b\S)?/g)
    .join("")
    .match(/(^\S|\S$)?/g)
    .join("")
    .toUpperCase();
};

export const postMultiPartData = async (url, fileList = [], obj = {}) => {
  try {
    const formData = new FormData();

    for (let i = 0; i < fileList.length; i++) {
      formData.append("files[]", fileList[i]);
    }
    formData.append("obj", JSON.stringify(obj));
    return await fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data
        return { success: true, response: data };
      })
      .catch((error) => {
        return { success: false, response: error };
      });
  } catch (error) {
    return { success: false, response: error };
  }
};

export const postJsonData = async (url, obj = {}) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ ...obj }),
    };
    return await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return { success: false, response: error };
      });
  } catch (error) {
    return { success: false, response: error };
  }
};

export const putJsonData = async (url, obj = {}) => {
  try {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ ...obj }),
    };
    return await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return { success: false, response: error };
      });
  } catch (error) {
    return { success: false, response: error };
  }
};

export const postFormData = async (url, formData) => {
  try {
    let formDataObject = Object.fromEntries(formData.entries());
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(formDataObject),
    };
    return await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data
        return { success: true, response: data };
      })
      .catch((error) => {
        return { success: false, response: error };
      });
  } catch (error) {
    return { success: false, response: error };
  }
};

export const deleteRequest = async (url, id = "") => {
  try {
    url = id !== "" ? url + "?key=" + id : url;
    const response = await fetch(url, { method: "delete" }).then((res) =>
      res.json()
    );
    return response;
  } catch (ex) {
    console.log(ex);
    return { success: false, response: ex };
  }
};

export const MobileInput = (props) => {
  const [value, setValue] = useState(props?.value ? props.value : "");
  const [isInValid, setIsInValid] = useState(false);
  const prop = {
    type: "text",
    name: "mobile",
    ...props,
    value: value,
    minLength: 10,
    maxLength: 10,
  };
  const handleChange = ({ target }) => {
    const inputFieldValue = target.value;
    if (isNaN(inputFieldValue) || inputFieldValue.length > 10) {
      return false;
    }
    setValue(inputFieldValue);
    if (inputFieldValue.length === 10) {
      setIsInValid(false);
    } else {
      setIsInValid(true);
    }
  };
  return (
    <Form.Control {...prop} onChange={handleChange} isInvalid={isInValid} />
  );
};

export const TooltipLink = ({ id, children, title }) => (
  <OverlayTrigger placement="auto" overlay={<Tooltip id={id}>{title}</Tooltip>}>
    {children}
  </OverlayTrigger>
);

export const Select = forwardRef(function Select(
  {
    inputProps,
    dataUrl,
    options = [],
    defaultLabel = "",
    valueElement = "value",
    displayElement = "label",
  },
  ref
) {
  let initialData =
    defaultLabel !== ""
      ? [{ [displayElement]: defaultLabel, [valueElement]: "" }, ...options]
      : options;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  async function fetchData() {
    let fetchedData = [];
    if (dataUrl) {
      try {
        setLoading(true);
        const response = await api.get(dataUrl).then((res) => res.data);
        if (response.success) {
          fetchedData = response.response;
        }
      } catch (ex) {
        console.log(ex);
      } finally {
        setLoading(false);
      }
    }
    // const newData =
    //   defaultLabel !== ""
    //     ? [{ [displayElement]: defaultLabel, [valueElement]: "" }, ...options]
    //     : options;
    setData([...fetchedData]);
  }
  useEffect(() => {
    fetchData();
  }, [dataUrl]);

  const internalRef = useRef();
  useImperativeHandle(ref, () => {
    return {
      input: internalRef.current,
      refresh() {
        fetchData();
      },
    };
  });
  //if (loading) return <>Loading</>;
  return (
    <>
      {!loading && (
        <Form.Select {...inputProps} ref={internalRef}>
          {initialData.map((option, index) => {
            return (
              <option value={option[valueElement]} key={index}>
                {option[displayElement]}
              </option>
            );
          })}
          {data.map((option, index) => {
            return (
              <option value={option[valueElement]} key={index}>
                {option[displayElement]}
              </option>
            );
          })}
        </Form.Select>
      )}
    </>
  );
});

export const parseEvent = (events) => {
  const eventData = [];
  var eventCount = 1;
  for (let i = 0; i < events.length; i++) {
    const event = {
      ...events[i],
      borderColor: "gray",
      backgroundColor: "lightgray",
      textColor: "black",
    };
    // event.groupId = event.activity_id;
    // event.title = event.title ? event.title : title;
    var today = new Date();
    var from_date = new Date(event.effective_from_date);
    var to_date = new Date(event.effective_to_date);
    if (event.month) {
      if (event.week_day) {
        for (let j = from_date.getFullYear(); j <= to_date.getFullYear(); j++) {
          var month_firstDate = new Date(j, event.month, 1);
          var month_lastDate = new Date(j, event.month + 1, 0);
          month_firstDate =
            month_firstDate < from_date ? from_date : month_firstDate;
          month_lastDate = month_lastDate > to_date ? to_date : month_lastDate;
          //add 1 day to month_lastDate
          month_lastDate.setDate(month_lastDate.getDate() + 1);
          eventData.push({
            ...event,
            daysOfWeek: [event.week_day],
            startRecur: month_firstDate < today ? today : month_firstDate,
            endRecur: month_lastDate,
            startTime: event.start_time,
            endTime: event.end_time,
            id: event.bp_br_activity_schedule_id.toString() + eventCount++,
          });
        }
      } else if (event.date) {
        for (let j = from_date.getFullYear(); j <= to_date.getFullYear(); j++) {
          var eventDate = new Date(j, event.month, event.date);
          if (eventDate >= from_date && eventDate <= to_date) {
            var startTime = eventDate;
            startTime.setHours(
              event.start_time.split(":")[0],
              event.start_time.split(":")[1]
            );
            var endTime = eventDate;
            endTime
              .setHours(
                event.end_time.split(":")[0],
                event.end_time.split(":")[1]
              )
              .setDate(endTime.getDate() + 1);
            eventData.push({
              ...event,
              start: startTime,
              end: endTime,
              id: event.bp_br_activity_schedule_id.toString() + eventCount++,
            });
          }
        }
      }
    } else if (event.week_day) {
      to_date = new Date(event.effective_to_date);
      to_date.setDate(to_date.getDate() + 1);
      eventData.push({
        ...event,
        startRecur: from_date < today ? today : from_date,
        endRecur: to_date,
        startTime: event.start_time,
        endTime: event.end_time,
        daysOfWeek: [event.week_day],
        id: event.bp_br_activity_schedule_id.toString() + eventCount++,
      });
    } else {
      from_date = new Date(event.effective_from_date);
      to_date = new Date(event.effective_to_date);
      from_date.setHours(
        event.start_time.split(":")[0],
        event.start_time.split(":")[1]
      );
      to_date
        .setHours(event.end_time.split(":")[0], event.end_time.split(":")[1])
        .setDate(to_date.getDate() + 1);
      eventData.push({
        ...event,
        start: from_date < today ? today : from_date,
        end: to_date,
        id: event.bp_br_activity_schedule_id.toString() + eventCount++,
      });
    }
  }
  return eventData;
};
